import { CLEAR_VERIFICATION_DATA } from '../constants/verificationConstants';

export const clearVerificationData = () => {
  return {
    type: CLEAR_VERIFICATION_DATA
  };
};
